(() => {
  const PRODUCT_ID = '9506132951286';
  const MEDIA = {
    sixOriginal: '38968706400502',
    sixCocoa: '38968727765238',
    twelveOriginal: '38968713576694',
    twelveCocoa: '38968732025078',
    twentyFourOriginal: '38968722620662',
    twentyFourCocoa: '38968736055542',
    originalCutaway: '38968740184310',
    cocoaCutaway: '38968743985398'
  };
  const ALL_MEDIA = Object.values(MEDIA);

  const getRoot = () =>
    document.querySelector(`product-info[data-product-id="${PRODUCT_ID}"]`) ||
    document.querySelector(`product-info[id*="${PRODUCT_ID}"]`);

  function normalizeOption(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    return String(value.value ?? value.name ?? value.label ?? '');
  }

  function selectionsFromControls(root) {
    const values = [];
    root.querySelectorAll('variant-selects input[type="radio"]:checked').forEach((input) => values.push(input.value));
    root.querySelectorAll('variant-selects select').forEach((select) => values.push(select.value));
    return values.filter(Boolean);
  }

  function selectedPair(root, variant) {
    let values = Array.isArray(variant?.options) ? variant.options.map(normalizeOption) : [];
    if (!values.length) values = selectionsFromControls(root);

    const joined = `${values.join(' ')} ${normalizeOption(variant?.title)}`.toLowerCase();

    const isCocoa = joined.includes('cocoa');
    let packageMedia = isCocoa ? MEDIA.sixCocoa : MEDIA.sixOriginal;

    if (/\b24\b/.test(joined) || joined.includes('large')) {
      packageMedia = isCocoa ? MEDIA.twentyFourCocoa : MEDIA.twentyFourOriginal;
    } else if (/\b12\b/.test(joined) || joined.includes('medium')) {
      packageMedia = isCocoa ? MEDIA.twelveCocoa : MEDIA.twelveOriginal;
    }

    const cutawayMedia = isCocoa ? MEDIA.cocoaCutaway : MEDIA.originalCutaway;
    return { packageMedia, cutawayMedia, keep: new Set([packageMedia, cutawayMedia]) };
  }

  function mediaIdFromAttribute(value) {
    if (!value) return null;
    return ALL_MEDIA.find((id) => String(value).endsWith(`-${id}`) || String(value) === id) || null;
  }

  function setElementVisibility(element, shouldShow) {
    if (shouldShow) {
      element.style.removeProperty('display');
      element.removeAttribute('aria-hidden');
    } else {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    }
  }

  function applyGalleryFilter(variant) {
    const root = getRoot();
    if (!root) return;

    const { packageMedia, keep } = selectedPair(root, variant);
    const gallery = root.querySelector('media-gallery');
    if (!gallery) return;

    let packageMediaTarget = null;

    gallery.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
      const id = mediaIdFromAttribute(item.getAttribute('data-media-id'));
      if (!id) return;
      const shouldShow = keep.has(id);
      setElementVisibility(item, shouldShow);
      if (id === packageMedia) packageMediaTarget = item.getAttribute('data-media-id');
    });

    gallery.querySelectorAll('.thumbnail-list__item[data-target]').forEach((item) => {
      const id = mediaIdFromAttribute(item.getAttribute('data-target'));
      if (id) setElementVisibility(item, keep.has(id));
    });

    document.querySelectorAll('product-modal [data-media-id]').forEach((item) => {
      const id = mediaIdFromAttribute(item.getAttribute('data-media-id'));
      if (id) setElementVisibility(item, keep.has(id));
    });

    gallery.querySelectorAll('.slider-counter--total').forEach((counter) => {
      counter.textContent = '2';
    });
    gallery.querySelectorAll('.slider-counter--current').forEach((counter) => {
      counter.textContent = '1';
    });

    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.initPages === 'function') slider.initPages();
    });

    if (packageMediaTarget && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(packageMediaTarget, true);
    } else if (packageMediaTarget) {
      const target = gallery.querySelector(`[data-media-id="${packageMediaTarget}"]`);
      target?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }
  }

  function scheduleApply(variant) {
    requestAnimationFrame(() => {
      applyGalleryFilter(variant);
      setTimeout(() => applyGalleryFilter(variant), 80);
      setTimeout(() => applyGalleryFilter(variant), 220);
    });
  }

  function initPalmariaGallery() {
    const root = getRoot();
    if (!root || root.dataset.palmariaGalleryReady === 'true') {
      if (root) scheduleApply();
      return;
    }

    root.dataset.palmariaGalleryReady = 'true';
    scheduleApply();

    root.addEventListener('change', () => setTimeout(() => scheduleApply(), 0));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data || {};
        if (data.sectionId && root.dataset.section && String(data.sectionId) !== String(root.dataset.section)) return;
        scheduleApply(data.variant);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPalmariaGallery);
  } else {
    initPalmariaGallery();
  }

  document.addEventListener('shopify:section:load', initPalmariaGallery);
})();